/* Three Blonde Mice — theme scripts */
(function () {
  'use strict';

  // Mobile menu
  document.querySelectorAll('.menu-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Quantity +/- buttons
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var v = (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty-step'), 10);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Cart: auto-update when quantity changes
  document.querySelectorAll('form[data-cart-form]').forEach(function (form) {
    var t;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(function () { form.submit(); }, 450);
    });
  });

  // Collection sort
  document.querySelectorAll('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Product gallery
  function showMedia(section, mediaId) {
    var slides = section.querySelectorAll('[data-media-id]');
    var found = false;
    slides.forEach(function (s) {
      if (String(s.getAttribute('data-media-id')) === String(mediaId)) found = true;
    });
    if (!found) return;
    slides.forEach(function (s) {
      s.classList.toggle('is-active', String(s.getAttribute('data-media-id')) === String(mediaId));
    });
    section.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', String(t.getAttribute('data-thumb')) === String(mediaId) ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    section.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(section, t.getAttribute('data-thumb')); });
    });

    var dataEl = section.querySelector('[data-variant-json]');
    var picker = section.querySelector('[data-variant-picker]');
    if (!dataEl || !picker) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = section.querySelector('form[data-product-form] input[name="id"]');
    var addBtn = section.querySelector('[data-add-button]');
    var priceEl = section.querySelector('[data-price]');

    function selectedOptions() {
      return Array.prototype.map.call(picker.querySelectorAll('fieldset'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    picker.addEventListener('change', function () {
      var opts = selectedOptions();
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!addBtn) return;
      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        if (priceEl) priceEl.innerHTML = '<span class="unavailable">This combination isn’t available</span>';
        return;
      }
      if (idInput) idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? addBtn.getAttribute('data-add-label') : 'Sold out';
      if (priceEl) priceEl.innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : '');
      if (v.media) showMedia(section, v.media);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });
})();
